export default "__VITE_ASSET__DT_MqT8O__"